import { Injectable } from '@angular/core';
import { ServiceLibrary } from '@common_libraries/helpers/ServiceLibrary';
import { Dictionary } from '@common_libraries/helpers/Dictionary';


@Injectable({providedIn: 'root'})
export class ModuleAuthService {

  public constructor(private servLib: ServiceLibrary) {
  }

  GetModulesForCurrentUser() {
    // don't need any params
    const parameters = new Dictionary([]);

    return this.servLib.HttpPost('/v1/api/ModuleAuth/GetModulesForCurrentUser', ServiceLibrary.ContentType.JSON, parameters);
  }

}
